import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomHttp } from '../../shared/custom.http';
import { DataAnalomy } from './model/dataanamoly';
import { DataAnalomyRequest } from './model/dataanamolyRequest';

import 'rxjs/add/operator/toPromise';
import { ApiConstants } from '../../shared';


@Injectable()
export class DataAnamolyService {

    private anamolyUrl = '/anomalies/v1';  // URL to web api
    constructor(private router: Router, private http: CustomHttp, private apiConstants: ApiConstants) {
    }
    getWikiAnamoly(dateFrom: string, dateTo: string) {
        const url = `${this.anamolyUrl}/wiki?dateFrom=${dateFrom}&dateTo=${dateTo}`;
        return this.http.get(url, { body: '' });
    }

    updateAnamoly(anamoly: DataAnalomyRequest): Promise<DataAnalomyRequest> {
        const url = `${this.anamolyUrl}/save/dataanamoly`;
        return this.http.post(url, JSON.stringify(anamoly));
    }


    refreshPortalCache() {
        return this.http.post(this.apiConstants.getPortalRefreshCacheUrl(), JSON.stringify(''));
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/dataanamoly/dataanamoly.service.ts